module.exports = __webpack_public_path__ + "img/banner-homealt.7f96fbdf.jpeg";